var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('font-awesome-icon',{attrs:{"icon":"spinner-third","size":"4x","spin":""}}),_c('div',[_vm._v(_vm._s(_vm.$t('app.loadingApp')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }